import { FormField } from 'ui/formField';
import { useQueryParamContext } from '../context/QueryParamContext';
import { SETTINGS_DISPLAY_CONTENT } from './constants';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { TemplateEditViews } from './types';
import { RawEditField } from './RawEditField';
import { RawPreviewField } from './RawPreviewField';

export const RawDataForm = () => {
  const { isEditMode: isEditModeContext } = useEditableFieldsContext();
  const { view } = useQueryParamContext();
  const isEditMode = view === TemplateEditViews.preview || isEditModeContext;

  return (
    <FormField isHorizontalLayout labelText={SETTINGS_DISPLAY_CONTENT.rawData.labelText}>
      {isEditMode ? <RawEditField /> : <RawPreviewField />}
    </FormField>
  );
};
